module.exports = __webpack_public_path__ + "static/media/partner-logo1.6e9b5c7e.png";